import { AppleSignInError } from '@freelancer/auth';
import { FacebookSignInError } from '@freelancer/facebook';
import { ErrorCodeApi } from 'api-typings/errors/errors';

export const exceptionErrors = [
  // Unknown errors created by the datastore or services
  'UNKNOWN',
  'UNKNOWN_ERROR',
  'NETWORK_ERROR',
  'SERVER_ERROR',
  // Generic errors returned by the backend
  ErrorCodeApi.INTERNAL_SERVER_ERROR,
  ErrorCodeApi.TOO_MANY_REQUESTS,
  ErrorCodeApi.UNAUTHORIZED,
  AppleSignInError.UNKNOWN,
  FacebookSignInError.UNKNOWN,
];

export enum GenericErrorAlign {
  LEFT = 'left',
  CENTER = 'center',
}
